<h1>Modelo do plano de atividades</h1>

<button mat-stroked-button (click)="download()" title="Download"><mat-icon>file_download</mat-icon> Download</button>

<app-alerta-carga-horaria-sisgrad></app-alerta-carga-horaria-sisgrad>
